import { shimmer, toBase64 } from "@src/utils/shimmer";
import Image from "next/image";
import React from "react";
import flower from "../../../../public/images/pinkFlowerImage.png";
import { EventBySlugQuery } from "@src/@types/api.d";
import Icon from "@src/components/Icon";
import { motion } from "framer-motion";

interface IFooter {
  slug: EventBySlugQuery | undefined;
}

const Footer = ({ slug }: IFooter) => {
  return (
    <footer className="w-full min-h-[30rem] overflow-hidden bg-[#E2D4D2] flex flex-col">
      <div className="h-[15rem] flex flex-col gap-2 justify-center items-center relative px-8 overflow-hidden text-[#2C1D1D] border-b-4 border-black mb-1">
        <Icon iconName="ring" />

        <p className="font-neue text-[1rem] md:text-[1.5rem] leading-[100%] mt-[2rem] font-light">
          MADE WITH{" "}
          <a
            href="https://www.inawo.com"
            target="_blank"
            rel="noopener noreferrer"
            className="border-b-[0.5px] border-[#2C1D1D] pb-[0.5px]"
          >
            INAWO
          </a>
        </p>

        <p className="font-ebGaramond text-[1rem] md:text-[1.5rem] leading-[100%] mt-[1rem] w-[60%] md:w-full text-center">
          The number one website maker for the culturally relevant
        </p>
      </div>

      <div className="h-[20rem]">
        <div className="h-[4rem] border-t border-black"></div>
        <div className="h-[12rem] relative overflow-hidden">
          <div
            className="absolute inset-0 z-0"
            style={{
              backgroundImage: `url('/images/t8-pattern.png')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />

          {/* Black overlay */}
          <motion.div
            className="absolute inset-0 bg-black/50 z-10"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1 }}
          />

          {/* Optional: add content here if needed */}
          <div className="relative z-20 flex justify-center items-center h-full">
            {/* Any footer message or design element */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
